// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperationCondition } from './operationCondition';
import { EmissionType } from './emissionType';
import { DeterminationType } from './determinationType';
import { BelowLdLq } from './belowLdLq';
import { DataType } from './dataType';
import { MonitoringType } from './monitoringType';
import { EntryStatus } from './entryStatus';
import { AirEntryCommentView } from './airEntryCommentView';


export interface AirEntriesView { 
    /**
     * The AirEntry primary key
     */
    id: number;
    /**
     * The parameter id
     */
    idParameter: number;
    /**
     * The shop id
     */
    idShop: number;
    /**
     * The tool id
     */
    idTool: number;
    /**
     * The emission point id
     */
    idEmissionPoint: number;
    /**
     * The site id
     */
    idSite: number;
    /**
     * The period id
     */
    idPeriod: number;
    /**
     * The entry cycle id
     */
    idEntryCycle: number;
    /**
     * The value of the air entry measurement
     */
    value: number;
    /**
     * The unit of the air entry measurement
     */
    unit: string;
    belowLdLq: AirEntriesView.BelowLdLqEnum | null;
    determinationType: DeterminationType;
    status: EntryStatus;
    dataType: DataType;
    emissionType: EmissionType;
    monitoringType: MonitoringType;
    /**
     * The oxygen content of the air entry
     */
    oxygenContent: number;
    operationCondition: OperationCondition;
    /**
     * The user id who updated the air entry
     */
    updatedBy: number;
    /**
     * The user id who reviewed the air entry
     */
    approvedBy: number;
    /**
     * The date and time the air entry was reviewed
     */
    approvedAt: string;
    /**
     * List of comments related to the air entry
     */
    comments: Array<AirEntryCommentView>;
}
export namespace AirEntriesView {
    export type BelowLdLqEnum = 'LD' | 'LQ';
    export const BelowLdLqEnum = {
        LD: 'LD' as BelowLdLqEnum,
        LQ: 'LQ' as BelowLdLqEnum
    };
}


